"use client";

import { cn } from "@/lib/utils/utils";
import BreadCrumbList from "./breadCrumbList";
import Text from "./text";
import useLocalizer from "@/hooks/useLocalizer";
import Flex from "../core/flex";
import Image from "next/image";

interface Props {
  className?: string;
  title: string;
  image?: string;
  breadcrumbItems?: {
    name: string;
    href?: string;
  }[];
}

const Banner: React.FC<Props> = ({
  className,
  title,
  image,
  breadcrumbItems,
}) => {
  const { t } = useLocalizer();
  return (
    <section className={cn("relative", className)}>
      <div className="relative h-80 overflow-hidden">
        {image && (
          <Image
            src={image}
            alt={title}
            fill
            priority
            className="object-cover -top-10"
          />
        )}
        <Flex
          direction="col"
          center
          className="w-full h-full bg-black/50 z-20 relative"
        >
          <BreadCrumbList
            items={[
              {
                name: t("pages.home"),
                href: "/",
              },
              ...(breadcrumbItems || []),
            ]}
          />
          <Text as="h1" className="text-white text-center px-2">
            {title}
          </Text>
        </Flex>
      </div>
    </section>
  );
};

export default Banner;
